import {type ClassValue, clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

/**
 * Merges Tailwind classes, resolving conflicts so the LAST class wins — the
 * same helper business-web uses (packages/business-web/src/lib/utils.ts).
 *
 * This matters more here than plain string concatenation would suggest: this
 * project sets `important: true` in tailwind.config, so every utility compiles
 * as `!important`. Concatenating a base class and an override leaves both in
 * the class attribute, and between two equally-specific !important rules the
 * winner is decided by generated-stylesheet order, not by the order they
 * appear on the element — which makes className overrides unreliable. twMerge
 * removes the losing class from the attribute entirely, so there is no cascade
 * fight to lose.
 *
 * Note it only resolves conflicts within the same property group: `w-full` vs
 * `w-max` dedupes, but `w-full` vs `max-w-max` does not (width vs max-width).
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export default cn;
